const apiResponse = {
  skillsDistribution: [
    {
      topic: "Java",
      subtopic: "Basic Syntax and Structure",
      questionTypes: [
        {
          questions: [
            {
              maxScore: 60,
              difficulty: "MEDIUM",
              questionType: "SUBJECTIVE",
              questionStatement:
                "Refactor ShopEasy's monolithic architecture into microservices focusing on performance and lightweight environment.",
              expectedTimeToSolveForStudentInSeconds: 720,
            },
          ],
          questionType: "SUBJECTIVE",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
        {
          questions: [
            {
              questionType: "PSEUDO_CODE",
              difficulty: "EASY",
              questionStatement:
                "Write a Java program to parse order details from an XML file and display them.",
              expectedTimeToSolveForStudentInSeconds: 720,
              maxScore: 30,
            },
          ],
          questionType: "PSEUDO_CODE",
          difficultyLevel: "EASY",
          numberOfQuestions: 1,
        },
        {
          questions: [
            {
              maxScore: 60,
              difficulty: "MEDIUM",
              questionType: "PSEUDO_CODE",
              questionStatement:
                "Write a Java method to calculate the total cost of items in a shopping cart.",
              expectedTimeToSolveForStudentInSeconds: 720,
            },
          ],
          questionType: "PSEUDO_CODE",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
        {
          questions: [
            {
              options: [
                { optionStatement: "Using integer types for calculations." },
                {
                  optionStatement:
                    "Using floating-point numbers for precision.",
                },
                {
                  optionStatement: "Defining variables without initialization.",
                },
                {
                  optionStatement:
                    "Implementing concatenation for computation.",
                },
              ],
              maxScore: 20,
              difficulty: "MEDIUM",
              questionType: "MCQ",
              correctOption: 2,
              questionStatement:
                "What is a key syntax consideration for calculating compound interest in Java?",
              expectedTimeToSolveForStudentInSeconds: 240,
            },
          ],
          questionType: "MCQ",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: false,
    },
    {
      topic: "Java",
      subtopic: "Object-Oriented Programming Concepts",
      questionTypes: [
        {
          questions: [
            {
              maxScore: 60,
              difficulty: "MEDIUM",
              questionType: "SUBJECTIVE",
              questionStatement:
                "Design a data model for a friend suggestion system using OOP concepts.",
              expectedTimeToSolveForStudentInSeconds: 720,
            },
          ],
          questionType: "SUBJECTIVE",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
        {
          questions: [
            {
              options: [
                { optionStatement: "Inherit from an abstract superclass." },
                {
                  optionStatement:
                    "Use composition with a ProfileManager class.",
                },
                {
                  optionStatement:
                    "Create an interface for multiple implementations.",
                },
                {
                  optionStatement:
                    "Use static methods in the UserProfile class.",
                },
              ],
              maxScore: 20,
              difficulty: "MEDIUM",
              questionType: "MCQ",
              correctOption: 2,
              questionStatement:
                "How would you refactor a UserProfile class to avoid code redundancy?",
              expectedTimeToSolveForStudentInSeconds: 240,
            },
          ],
          questionType: "MCQ",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: false,
    },
    {
      topic: "Java",
      subtopic: "Exception Handling",
      questionTypes: [
        {
          questions: [
            {
              maxScore: 90,
              difficulty: "HARD",
              questionType: "SUBJECTIVE",
              questionStatement:
                "Design an exception handling strategy for a payment processing system.",
              expectedTimeToSolveForStudentInSeconds: 720,
            },
          ],
          questionType: "SUBJECTIVE",
          difficultyLevel: "HARD",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: false,
    },
    {
      topic: "Data Structures and Algorithms",
      subtopic: "Array Manipulation",
      questionTypes: [
        {
          questions: [
            {
              maxScore: 80,
              difficulty: "MEDIUM",
              questionType: "CODE",
              questionStatement:
                "Find the 2nd largest element in an unsorted array without sorting.",
              expectedTimeToSolveForStudentInSeconds: 900,
            },
          ],
          questionType: "CODE",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: true,
    },
    {
      topic: "Data Structures and Algorithms",
      subtopic: "Graph Traversal (BFS/DFS)",
      questionTypes: [
        {
          questions: [
            {
              maxScore: 120,
              difficulty: "HARD",
              questionType: "CODE",
              questionStatement:
                "Remove a redundant edge from a directed graph to convert it into a rooted tree.",
              expectedTimeToSolveForStudentInSeconds: 600,
            },
          ],
          questionType: "CODE",
          difficultyLevel: "HARD",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: true,
    },
  ],
  totalQuestions: 9,
};

const allQuestions: {
  maxScore: number;
  difficulty: string;
  questionType: string;
  questionStatement: string;
  expectedTimeToSolveForStudentInSeconds: number;
}[] = [];

apiResponse.skillsDistribution.forEach((topic) => {
  topic.questionTypes.forEach((questionType) => {
    questionType.questions.forEach((question) => {
      const enrichedQuestion = {
        ...question,
        topic: topic.topic,
        subtopic: topic.subtopic,
        isDSARelatedTopic: topic.isDSARelatedTopic,
      };
      allQuestions.push(enrichedQuestion);
    });
  });
});

export const QuestionData = {
  allQuestions,
  totalQuestions: apiResponse.totalQuestions,
};

export const TopicData = {
  topics: [
    {
      topic: "Arrays",
      subtopic: "Basic Operations",
      questionTypes: [
        {
          questionType: "CODE",
          difficultyLevel: "EASY",
          numberOfQuestions: 1,
        },
        {
          questionType: "MCQ",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: true,
    },
    {
      topic: "Graphs",
      subtopic: "Graph Traversal (BFS/DFS)",
      questionTypes: [
        {
          questionType: "CODE",
          difficultyLevel: "HARD",
          numberOfQuestions: 1,
        },
        {
          questionType: "MCQ",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: true,
    },
    {
      topic: "Dynamic Programming",
      subtopic: "Optimization Problems",
      questionTypes: [
        {
          questionType: "SUBJECTIVE",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: true,
    },
    {
      topic: "Bit Manipulation",
      subtopic: "Binary Representation",
      questionTypes: [
        {
          questionType: "CODE",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: true,
    },
    {
      topic: "Recursion",
      subtopic: "Backtracking",
      questionTypes: [
        {
          questionType: "CODE",
          difficultyLevel: "HARD",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: true,
    },
    {
      topic: "Sorting",
      subtopic: "Comparison-Based Sorting",
      questionTypes: [
        {
          questionType: "MCQ",
          difficultyLevel: "EASY",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: true,
    },
    {
      topic: "Linked List",
      subtopic: "Basic Operations",
      questionTypes: [
        {
          questionType: "CODE",
          difficultyLevel: "MEDIUM",
          numberOfQuestions: 1,
        },
      ],
      isDSARelatedTopic: true,
    },
  ],
  totalDuration: 6420,
  totalQuestions: 9,
};
